// extracted by mini-css-extract-plugin
module.exports = {"base":"CBModules_base__QnZ-U","paddingSection":"CBModules_paddingSection__3K6X1"};